'use strict';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import noop from 'lodash/noop';
import * as T from 'prop-types';
import React from 'react';
import {DropdownListField} from '../../../components/forms/DropdownListField';
import {FormField, INPUT_TYPES} from '../../../components/forms/FormField';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {PeopleItem} from '../../../personnel/components/PeopleItem';


const optionConfigPoc = {
  component: PeopleItem,
  className: null,
  placeholderClassName: "OrgCard__poc",
  props: {
    isSimple: true,
    isOption: true,
    showName: true,
    avatarImageWidth: 20,
    avatarImageHeight: 20,
    nullLabel: 'personnel.select.null.label',
  },
};

export function BaseOrganizationFormView(props) {
  const canEdit = props.canEdit || {};
  const constraints = props.constraints || {};
  const internalModel = props.internalModel || {};
  const onChange = props.onChange || {};

  const handleChangeName = onChange.name || noop;
  const handleChangeDescription = onChange.description || noop;
  const handleChangePoc = onChange.poc || noop;

  const pocProps = props.pocProps || {};
  const handleFocusPoc = pocProps.onFocus;
  const handleFilterChangePoc = pocProps.onFilterChange;
  const handleLoadMorePoc = pocProps.onLoadMore;

  return (
    <form
      className={classNames("OrganizationForm", props.className)}
      onSubmit={props.onSave}
    >
      <input
        type="submit"
        hidden={true}
      />
      <FormField
        className={classNames("OrganizationForm__field", props.fieldClass)}
        type={INPUT_TYPES.text}
        label={props.nameLabel}
        value={internalModel.name}
        disabled={!canEdit.name}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.name}
        onChange={handleChangeName}
        isErrorAfterLabel={true}
      />
      <FormField
        className={classNames("OrganizationForm__field", props.fieldClass)}
        type={INPUT_TYPES.text_long}
        label={props.descriptionLabel}
        value={internalModel.description}
        validateImmediately={props.validateImmediately}
        isEditing={props.isEditing}
        isSaving={props.isSaving}
        constraints={constraints.description}
        onChange={handleChangeDescription}
        isErrorAfterLabel={true}
      />
      {props.showPoc ? (
        <DropdownListField
          className={classNames("OrganizationForm__field", props.fieldClass)}
          optionConfig={optionConfigPoc}
          label={props.pocLabel}
          value={internalModel.poc}
          nullLabel={props.nullLabelPoc}
          selectNull={false}
          options={pocProps.options}
          disabled={!canEdit.poc}
          validateImmediately={props.validateImmediately}
          isEditing={props.isEditing}
          isSaving={props.isSaving}
          getLabel={pocProps.getLabel}
          mode={pocProps.mode}
          minToFilter={!isNumber(pocProps.total) || pocProps.total < 20 ? 20 : 0}

          onChange={handleChangePoc}
          onFocus={handleFocusPoc}
          onFilterChange={handleFilterChangePoc}
          onLoadMore={handleLoadMorePoc}
        />
      ) : null}
    </form>
  );
}

BaseOrganizationFormView.propTypes = {
  className: T.string,
  /** @type {String} fieldClass The class applied to each field */
  fieldClass: T.string,
  showPoc: T.bool,

  // values
  pocProps: T.object,
  model: T.object,
  internalModel: T.object,

  canEdit: T.object,
  constraints: T.object,

  // Events
  onChange: T.object,
  onSave: T.func,

  // Form State
  isEditing: T.bool,
  isSaving: T.bool,

  nameLabel: T.string,
  descriptionLabel: T.string,
  pocLabel: T.string,
  nullLabelPoc: T.string,
};

export const OrganizationFormView = I18nComponent(BaseOrganizationFormView, [
  {code: 'organizations.properties.name.label', prop: 'nameLabel'},
  {code: 'organizations.properties.description.label', prop: 'descriptionLabel'},
  {code: 'organizations.properties.poc.label', prop: 'pocLabel'},
  {code: 'personnel.select.null.label', prop: 'nullLabelPoc'},
]);



// WEBPACK FOOTER //
// ./src/js/organizations/components/OrganizationForm/OrganizationFormView.js